export default {
    errorBanner: {
        dismiss: 'Dismiss',
    },
}
